import {actionIds, BaseAction} from "../common";

const reconnectAction: () =>
    BaseAction = () => ({
    type: actionIds.RECONNECT,
    payload: {},
});

export default reconnectAction;
